// components/TitleHelmet.tsx
import React from 'react';
import { Helmet } from 'react-helmet';

interface TitleHelmetProps {
  title: string;
}

const TitleHelmet: React.FC<TitleHelmetProps> = ({ title }) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
) as React.ReactElement;

export default TitleHelmet;
